module.exports = __webpack_public_path__ + "media/7_Long.202e298a.mp3";